import React from 'react'
import {
  Alert,
  Button,
} from 'react-bootstrap'

const Confirmation = ({
  message,
  onCancel,
  onConfirm
}) => (
  <Alert bsStyle="danger" onDismiss={onCancel}>
    <p>
      {message}
    </p>
    <p>
      <Button bsStyle="danger" onClick={onConfirm}>Yes</Button>
    </p>
  </Alert>
)
export default Confirmation


// WEBPACK FOOTER //
// ./src/components/Confirmation.js